
import {Component} from 'vue-property-decorator'
import {Base} from '~/core/Base'

@Component
export default class LabelTag extends Base {}
